/**
 * Single source of truth for the API gateway URL.
 * Set VITE_API_GATEWAY_URL in .env (e.g. .env or .env.local) to override.
 * Frontend: 4444, API gateway: 4445.
 */
const GATEWAY_URL = import.meta.env.VITE_API_GATEWAY_URL || 'http://89.24.183.108:4445'

/** API gateway base URL (no trailing slash). Change here or via VITE_API_GATEWAY_URL to affect all API calls. */
export const API_GATEWAY_BASE_URL = GATEWAY_URL.replace(/\/$/, '')

/** Base URL for REST API (gateway + /api). */
export const API_BASE_URL = `${API_GATEWAY_BASE_URL}/api`

/** WebSocket base URL (http -> ws, same host/port). */
export const WS_BASE_URL = GATEWAY_URL.replace(/^http/, 'ws').replace(/\/$/, '')
